import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Cache the platform settings for the lifetime of the tab — they're mutated
// rarely enough (super admin action) that a page reload is an acceptable refresh.
let _cache = null;
let _inflight = null;

export function loadPlatformSettings() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = axios.get(`${BACKEND_URL}/api/platform`, { withCredentials: false })
    .then(({ data }) => { _cache = data; return data; })
    .catch(() => ({ platform_name: "", banner_message: "", universal_theme: "light", signup_disabled: false, support_email: "" }))
    .finally(() => { _inflight = null; });
  return _inflight;
}

export function usePlatformSettings() {
  const [g, setG] = useState(_cache);
  useEffect(() => {
    if (_cache) { setG(_cache); return; }
    loadPlatformSettings().then(setG);
  }, []);
  return g;
}
